/* oxlint-disable
  vars-on-top,
  no-var,
  prefer-rest-params,
  guard-for-in,
  no-return-assign,
  no-func-assign,
  block-scoped-var
 */
/* eslint-disable
    consistent-return,
    no-restricted-syntax,
    no-shadow,
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import {assert, assertAndContinue} from 'Asserts';
import BenchlingCollection from 'BenchlingCollection';
import * as benchlingUtil from 'BenchlingUtil';
import * as context from 'Context';
import {maybeLogErrorResponseToSentry} from 'util/RequestCorrelation';
import {debounce} from 'ts-debounce';

export class SingletonModel extends Backbone.Model {
  static initClass() {
    this._instance = undefined;
  }
  static get(attributes, options) {
    // oxlint-disable-next-line no-cond-assign
    return this._instance != null ? this._instance : (this._instance = new this(attributes, options));
  }
  static resetForTests() {
    this._instance = undefined;
  }
}
SingletonModel.initClass();

export class SingletonCollection extends BenchlingCollection {
  static initClass() {
    this._instance = undefined;
  }
  static get(models, options) {
    // oxlint-disable-next-line no-cond-assign
    return this._instance != null ? this._instance : (this._instance = new this(models, options));
  }
  static resetForTests() {
    this._instance = undefined;
  }
}
SingletonCollection.initClass();

function getBatchField(triggerer, trigger, field) {
  if (trigger == null) {
    trigger = 'batch';
  }
  if (field == null) {
    field = '';
  }
  return `${trigger}-${triggerer.batchName()}${field ? `-${field}` : ''}`;
}

function batchModifyField(field, f, trigger) {
  let info;
  if (trigger == null) {
    trigger = 'batch';
  }
  const normField = getBatchField(this, trigger, field);
  (info = {})[normField] = true;
  context.using(info, this, f);

  if (!context.get(normField, false)) {
    this.get(field).trigger(trigger);
  }
}

function batchModifyModels(f, trigger) {
  if (trigger == null) {
    trigger = 'batch';
  }
  batchModifyCollections([this], this, f, trigger);
}

function batchModifyCollections(collections, caller, f, trigger) {
  let normField;
  if (trigger == null) {
    trigger = 'batch';
  }
  const info = {};
  for (var collection of Array.from(collections)) {
    normField = getBatchField(collection, trigger);
    info[getBatchField(collection, trigger)] = true;
  }
  context.using(info, caller, f);

  for (collection of Array.from(collections)) {
    normField = getBatchField(collection, trigger);
    if (!context.get(normField, false)) {
      collection.trigger(trigger);
    }
  }
}

function batch(fn, trigger) {
  if (trigger == null) {
    trigger = 'batch';
  }
  return this.listenToBatch(this, fn, trigger);
}

function listenToBatch(collection, fn, trigger) {
  // Wraps a function, delaying its call until batch gets triggered on the model/collection.

  // NB: This is a better alternative to silent: true, since it only affects the handler, and
  // better than debounce as we don't run into any weird timing issues.

  // The event triggerer should wrap calls in batchModify to create the appropriate context..

  if (trigger == null) {
    trigger = 'batch';
  }
  const normField = getBatchField(collection, trigger);

  let batchFlag = false;

  function newFn() {
    batch = context.get(normField, false);
    if (batch) {
      return (batchFlag = true);
    } else {
      batchFlag = false;
      return fn.call(this);
    }
  }

  this.listenTo(collection, trigger, function () {
    if (batchFlag) {
      return newFn.call(this);
    }
  });
  return newFn;
}

function inBatch(trigger) {
  if (trigger == null) {
    trigger = 'batch';
  }
  return context.get(getBatchField(this, trigger), false);
}

Backbone.Collection.prototype.inBatch = inBatch;
Backbone.Collection.prototype.batch = batch;
Backbone.Collection.prototype.listenToBatch = listenToBatch;
Backbone.Model.prototype.listenToBatch = listenToBatch;
Backbone.View.prototype.listenToBatch = listenToBatch;
Backbone.Collection.prototype.batchModify = batchModifyModels;
Backbone.Model.prototype.batchModify = batchModifyField;
Backbone.batchModify = batchModifyCollections;

Backbone.Model.prototype.fastUnset = function (attr) {
  return this.fastSet(attr, undefined);
};

Backbone.Model.prototype.fastSet = function (key, val) {
  // No change events, no cloning, just setting on the model.
  let attrs;
  if (key == null) {
    return this;
  }
  if (typeof key === 'object') {
    attrs = key;
  } else {
    (attrs = {})[key] = val;
  }

  for (const attr in attrs) {
    this.attributes[attr] = attrs[attr];
  }

  return this;
};

const normalSync = Backbone.sync;

let xhrCount = 0;
let longXHRCount = 0;
let fileUpdateXHRCount = 0;

function updateXHRCount(delta, {fileUpdate, skipFileUpdateXHRCount}) {
  assert([+1, -1].includes(delta));
  xhrCount += delta;
  if (fileUpdate && !skipFileUpdateXHRCount) {
    fileUpdateXHRCount += delta;
  }
}

function timeoutXHR(xhr) {
  let timedOut = false;

  function uhohTimeout() {
    Backbone.trigger('long-sync', ++longXHRCount);
    timedOut = true;
  }

  const id = setTimeout(uhohTimeout, 5000, xhr);

  xhr.always(() => {
    if (timedOut) {
      --longXHRCount;
    }
    clearTimeout(id);
  });
}

Backbone.getXHRCount = () => xhrCount;

// Key: namespace hyphenated with Backbone model's unique client ID.
// Value: debounced sync function to call and Deferred object to return.
const debouncedSyncMap = {};
// Value: last XHR associated with the key.
const singletonMap = {};

function normalSyncWithSingleton(method, model, options) {
  const xhr = normalSync.call(this, method, model, options);
  // If the sync should be a singleton (only one request in flight),
  // abort the previous request.
  if (options.singleton != null) {
    const key = `${options.singleton.namespace}-${model.cid}`;
    if (singletonMap[key] != null) {
      singletonMap[key].__suppress_notification = true;
      singletonMap[key].abort();
    }
    singletonMap[key] = xhr;
  }
  return xhr;
}

Backbone.sync = function (method, model, options) {
  let deferred, xhr;
  if (options == null) {
    options = {};
  }
  _.defaults(options, {
    debounce: null,
    respondDiff: false,
    fileUpdate: false,
    singleton: null,
    skipFileUpdateXHRCount: false,
    skipTimeoutXHR: false,
  });

  if (!options.fileUpdate) {
    return normalSyncWithSingleton(method, model, options);
  }

  // If the operation is only asks for a diff from the server (and will apply the diff),
  // then there should be no ongoing fileUpdate XHRs.
  if (fileUpdateXHRCount > 0 && !options.skipFileUpdateXHRCount) {
    deferred = $.Deferred();
    const emptyPromise = deferred.promise();
    // Error notification will be handled by premature-sync.
    deferred.reject({__suppress_notification: true});
    Backbone.trigger('premature-sync');
    return emptyPromise;
  }

  // If the sync should be debounced, call the debounced sync function
  // and return the empty promise from debouncedSyncMap.
  if (options.debounce != null) {
    const key = `${options.debounce.namespace}-${model.cid}`;
    // eslint-disable-next-line benchlint/no-in-operator
    if (key in debouncedSyncMap) {
      debouncedSyncMap[key].deferred.reject({__suppress_notification: true});
    } else {
      debouncedSyncMap[key] = {
        debouncedSync: debounce((method, model, options) => {
          ({deferred} = debouncedSyncMap[key]);
          delete debouncedSyncMap[key];
          normalSyncWithSingleton(method, model, options)
            .done(deferred.resolve.bind(deferred))
            .fail(deferred.reject.bind(deferred));
        }, options.debounce.wait),
      };
    }
    debouncedSyncMap[key].deferred = $.Deferred();
    xhr = debouncedSyncMap[key].deferred.promise();
    debouncedSyncMap[key].debouncedSync(method, model, options);
  } else {
    xhr = normalSyncWithSingleton(method, model, options);
  }

  if (!options.skipTimeoutXHR) {
    timeoutXHR(xhr);
  }
  updateXHRCount(+1, options);
  Backbone.trigger('syncing', xhr, xhrCount, longXHRCount);
  xhr
    .done(() => {
      updateXHRCount(-1, options);
      Backbone.trigger('good-sync', xhr, xhrCount, longXHRCount);
    })
    .fail((res) => {
      updateXHRCount(-1, options);
      if (benchlingUtil.shouldSuppressNotification(...arguments)) {
        return;
      }
      maybeLogErrorResponseToSentry(res);
      Backbone.trigger('fail-sync', xhr, xhrCount, longXHRCount);
    });
  return xhr;
};

const originalListenTo = Backbone.Model.prototype.listenTo;

Backbone.Model.prototype.listenTo = function (other, event, callback) {
  assertAndContinue(callback != null, 'Callback for listenTo was not defined');
  return originalListenTo.apply(this, arguments);
};
